import React, { useMemo, useState } from 'react';
import { Justify, SearchBox, Table } from 'tea-component';
import SourceTable from '../../../Sources/component/Table';
import { useSourcesTables } from '../../hooks';
import { useRouteMatch } from 'umi';
import { opinionsMetricsColumn, mobileGameFieldsColumn, pCConsoleFieldsColumn, companyFieldsColumn, deviceMetricsColumn } from '../../config';
export default function OpinionsMetrics(props: any) {
  const {
    loading,
    searchValue,
    dataSourceList,
    handleOnSearchTextList,
    handleOnSearchClear,
    handleOnChangeText,
    formatMessage,
  } = useSourcesTables();

  const [pageIndex, setPageIndex] = useState(1);

  const { params }: any = useRouteMatch() || {};
  const tabId = params?.tab;
  const columns = useMemo(() => {
    const config = {
      OpinionsMetrics: opinionsMetricsColumn(formatMessage),
      MobileGameFields: mobileGameFieldsColumn(formatMessage),
      PCConsoleFields: pCConsoleFieldsColumn(formatMessage),
      CompanyFields: companyFieldsColumn(formatMessage),
      DeviceMetrics: deviceMetricsColumn(formatMessage)
    }[tabId as string]
    return config
  }, [formatMessage, tabId])

  const handleOnChange = (word: string) => {
    if (word != '') {
      setPageIndex(1)
    } 
    handleOnChangeText(word);
  }
  return (
    <>
      <Table.ActionPanel>
        <Justify
          className="dbi-imurreports-justify"
          right={
            <SearchBox
              placeholder={formatMessage({ id: 'dbi_search_for_source' })}
              value={searchValue}
              onClear={handleOnSearchClear}
              onSearch={handleOnSearchTextList}
              onChange={handleOnChange}
            />
          }
        />
      </Table.ActionPanel>
      <SourceTable
        records={dataSourceList}
        columns={columns}
        loading={loading}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
      />
    </>
  );
}
